import { render, staticRenderFns } from "./SolicitacoesAcesso.vue?vue&type=template&id=47c0314f&"
import script from "./SolicitacoesAcesso.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports